export default __webpack_public_path__ + "static/media/feed2.2d4548fc.jpg";